// extracted by mini-css-extract-plugin
export default {"Scarlet":"error-page_Scarlet__RmHHH"};